"use strict";

define('service/submission',['require','exports','module','appkit/service','underscore','../libs/route.helper','app/study/detail/study.detail.controller'],function (require, exports, module) {
  var Service = require('appkit/service'),
    _ = require('underscore'),
    RouteHelper = require('../libs/route.helper'),
    StudyDetailController = require('app/study/detail/study.detail.controller');
  var SubmissionService = Service.extend({
    replies: {
      'decision:query': 'getReviewOrDecisionTypeForQuery'
    },
    createPDF: function createPDF(study, submission) {
      var legacyController = new (StudyDetailController.extend({
          setupListeners: function setupListeners() {}
        }))(app.legacyApp),
        popup = this.channel.request('pdf:popup');
      legacyController.setup($('<div/>'));
      legacyController.getStudyService().configure({
        studyId: study.get('id')
      });
      legacyController.setDocumentService(legacyController.getStudyService().documentService(submission.get('id')));
      return Promise.join(legacyController.loadStudyProperties(), legacyController.getDocumentService().getDocument()).tap(function () {
        return legacyController.createDocumentPdf(popup);
      })["finally"](legacyController.showLoading());
    },
    createLetterPDF: function createLetterPDF(input, popup) {
      var container = $('<div/>').html(input),
        imageQueue = [],
        app = this.app,
        maxWidth = 720;
      container.find('img').each(function (index, image) {
        var promise = app.request('imageDimensions', image),
          $image = $(image);
        if ($image.closest('ol').length || $image.closest('ul').length) {
          maxWidth = 700;
        }
        $image.before('<br/>');
        $(image).parent().css({
          'page-break-inside': 'avoid',
          display: 'block'
        });
        imageQueue.push(new Promise(function (resolve, reject) {
          (function (p, i, max) {
            p.tap(function (dimensions) {
              if (dimensions.width > max) {
                $(i).css({
                  width: max,
                  height: 'auto'
                });
              }
              resolve();
            });
          })(promise, image, maxWidth);
        }));
      });
      return Promise.all(imageQueue).tap(function () {
        app.execute('pdf', container, popup);
      });
    },
    getMeetingDetailLink: function getMeetingDetailLink(meeting, submission) {
      var routeHelper = new RouteHelper('submission:meetingDetail').add(meeting, {
        meetingId: 'id'
      }).add(submission, {
        documentId: 'id'
      });
      return routeHelper.get('link');
    },
    getReviewOrDecisionTypeForQuery: function getReviewOrDecisionTypeForQuery(decisionType, reviewType) {
      if (!decisionType) {
        return reviewType;
      }
      var decisionDescription = decisionType.get('description');
      if ('Exempt' === decisionDescription || 'Exempt - Limited IRB' === decisionDescription) {
        return decisionDescription;
      }
      return reviewType;
    },
    isClosure: function isClosure(submission) {
      return submission && submission.get('templateType') === 'Closure';
    },
    isFullExpeditedAvailable: function isFullExpeditedAvailable(decisions) {
      var lastDecisionType = null,
        lastDecisionRoute = null;
      if (!decisions.isEmpty()) {
        var lastDecision = decisions.max(function (decision) {
          return decision.get('finalizedDate');
        });
        lastDecisionType = lastDecision.get('type');
        lastDecisionRoute = lastDecision.get('decisionType') ? lastDecision.get('decisionType').get('route') : null;
      }
      return lastDecisionType == 'FULL' && lastDecisionRoute == 'Reopened';
    },
    navigateAndOpenChecklists: function navigateAndOpenChecklists(app) {
      var args = Array.prototype.slice.call(arguments, 1);
      app.legacyApp.store.set('document.edit.checklist', true);
      this.navigateToFormViewer.apply(this, args);
    },
    navigateToFormViewer: function navigateToFormViewer(model, mapping, options) {
      var link = RouteHelper.createLink('submission:edit', model, mapping);
      app.navigate(link, _.extend({}, {
        trigger: true
      }, options));
    },
    navigateToMeetingDetail: function navigateToMeetingDetail(meeting, submission, options) {
      var link = this.getMeetingDetailLink(meeting, submission);
      app.navigate(link, _.extend({}, {
        trigger: true
      }, options));
    },
    navigateToDocumentLetters: function navigateToDocumentLetters(model, options) {
      var link = RouteHelper.createLink('submission:letters', model, {
        documentId: 'id'
      });
      app.navigate(link, _.extend({}, {
        trigger: true
      }, options));
    },
    navigateToDocumentDecision: function navigateToDocumentDecision(model, options) {
      var link = RouteHelper.createLink('decision:make', model, {
        id: 'id'
      });
      app.navigate(link, _.extend({}, {
        trigger: true
      }, options));
    },
    navigateToDocumentDecisionHistory: function navigateToDocumentDecisionHistory(model, options) {
      var link = RouteHelper.createLink('decision:history', model, {
        decisionId: 'id'
      });
      app.navigate(link, _.extend({}, {
        trigger: true
      }, options));
    },
    navigateToAssignments: function navigateToAssignments(model, options) {
      var link = RouteHelper.createLink('submission:assignments', model, {
        documentId: 'id'
      });
      app.navigate(link, _.extend({}, {
        trigger: true
      }, options));
    },
    requestChangePolicy: function requestChangePolicy(submission, policy) {
      return submission.requestChangePolicy(policy).promise().tap(function () {
        submission.trigger('updateAll');
      });
    }
  });
  module.exports = SubmissionService;
});

